import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=56059b4c&"
import script from "./AddNew.vue?vue&type=script&lang=js&"
export * from "./AddNew.vue?vue&type=script&lang=js&"
import style0 from "./AddNew.vue?vue&type=style&index=0&id=56059b4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports